import { useMatchRoute } from "@tanstack/react-router";

import type { FileRoutesByTo } from "@/routeTree.gen";

export enum AppLayout {
  Default = "default",
  Aside = "aside",
  Navless = "navless",
}

const asideLayoutRoutes: (keyof FileRoutesByTo)[] = [
  "/login",
  "/logout",
  "/register",
  "/account/verify/complete-invite",
  "/account/verify/complete-signup",
  "/account/password/request",
  "/account/password/reset",
  "/account/password/set",
  "/account/verify/$type/$token",
];

const navlessLayoutRoutes: (keyof FileRoutesByTo)[] = [
  "/account/profile",
  "/welcome",
  "/academy",
  "/end-of-trial",
  "/terms-trial",
  "/privacy",
];

export function useAppLayout() {
  const matchRoute = useMatchRoute();

  let appLayout: AppLayout | null = null;

  if (asideLayoutRoutes.some((path) => matchRoute({ to: path }))) {
    appLayout = AppLayout.Aside;
  } else if (navlessLayoutRoutes.some((path) => matchRoute({ to: path }))) {
    appLayout = AppLayout.Navless;
  } else {
    appLayout = AppLayout.Default;
  }

  return { appLayout };
}
